import { GridRowId } from '@mui/x-data-grid-pro';
import { GridApiPro } from '@mui/x-data-grid-pro';

const prefix = 'EDDataGrid';

export const EDDataGridClasses = {
  linkText: `${prefix}-linkText`,
  functionMenu: `${prefix}-functionMenu`,
  summaryRow: `${prefix}-summaryRow`,
  cellDisabled: `${prefix}-cellDisabled`,
  cellReadonly: `${prefix}-cellReadonly`,
  menuColumnCellInEditableTable: `${prefix}-menuColumnCellInEditableTable`,
  importDialogCellInvalidValue: `${prefix}-importDialogCellInvalidValue`,
};

export const getFirstEditableField = (
  gridApi: GridApiPro | undefined,
  rowId: GridRowId
): string | undefined => {
  if (gridApi && gridApi.getAllColumns) {
    const fields = gridApi.getAllColumns().map(column => column.field);

    const editableField = fields?.find(field => {
      if (!gridApi.getAllRowIds().includes(rowId)) {
        return false;
      }

      const cellParams = gridApi.getCellParams(rowId, field);
      const cellIsEditable = gridApi.isCellEditable(cellParams);

      return cellIsEditable;
    });

    return editableField;
  }

  return undefined;
};

export const getFirstEditableCell = (
  gridApi: GridApiPro | undefined
): { id: GridRowId; field: string } | undefined => {
  const rowIds = gridApi?.getAllRowIds?.();

  let firstEditableField: string | undefined;
  const firstEditableRow = rowIds?.find(rowId => {
    firstEditableField = getFirstEditableField(gridApi, rowId);

    return firstEditableField != null;
  });

  if (firstEditableRow && firstEditableField) {
    return { id: firstEditableRow, field: firstEditableField };
  } else {
    return undefined;
  }
};
